/**
 * Pattern from Dan Abramov: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * Helps avoid previous issues where setInterval was trapping stale states
 */
import { useEffect, useRef } from "react";

export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Always keep the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay === null || delay === false) return;

    const id = setInterval(() => {
      savedCallback.current();
    }, delay);

    return () => clearInterval(id);
  }, [delay]);
}
